<template>
<div class="chapter">
<div class="inner_page">
<div class="fig">
<img alt="" height="92" src="OEBPS/images/fleuron.gif" width="90"/>
</div>
<h1 class="cn">PROLOGUE</h1>
<h1 class="ct">How Camest Thou in This Pickle?</h1>
<p class="nonindent">The handcuffs chafed my wrist, but that was nothing compared with the irritation I felt regarding the cretin to whom I was currently shackled.</p>
<p class="indent">I finally broke my silence, not with a word but with an—“Ow!”</p>
<p class="indent">“Jeez, Miranda, what now?”</p>
<p class="indent">“Would you stop yanking your arm around for two seconds?”</p>
<p class="indent">“I barely moved!”</p>
<p class="indent">“It’s like you have Tourette’s or something. My god!”</p>
<p class="indent">Caleb directed his green-grey eyes at me in a flash of annoyance.</p>
<p class="indent">“Listen, princess — I’m not enjoying this any more than you are. Now let’s think.” He shifted his glance to the towering cardboard boxes surrounding us. “There’s got to be some way out of here.”</p>
<p class="indent">“For the record, I don’t think the psycho who locked us in here conveniently left an escape route for us to find. By the way, if you call me princess again, I <em>will</em> scream.”</p>
<p class="indent">“At least maybe someone would hear us in here and let us out. Anyway, I thought you’re the one who’s supposed to have all the answers. Can’t you wave your magic mascara wand and conjure us out of here?”</p>
<p class="indent">“Very funny. Sorry, but being handcuffed to your ass for the last six hours has robbed me of my powers — not to mention my will to live. And don’t think I wouldn’t kill to have some mascara right about now. I’m sure I look like a hot mess.”</p>
<p class="indent">“Quite the opposite, actually.” His unforeseen compliment threw me off guard. Flustered, I redoubled my efforts at cynicism, shifting awkwardly on the cold cement floor.</p>
<p class="indent">“With my luck, there are rats lurking around here somewhere. Maybe they can chew through these handcuffs and liberate me. I still cannot believe we don’t have the key.”</p>
<p class="indent">“We’re not having this conversation again.”</p>
<p class="indent">I sighed and shifted uncomfortably on my butt bones.</p>
<p class="indent">“What’s wrong now?”</p>
<p class="indent">“Nothing. My back hurts.” Caleb abruptly leaned away from me and started rooting in the corner of the storeroom, as far as he could reach, with his one free hand. Just as I was about to blast him again for jerking me around, he hoisted up a clear plastic garbage bag filled with Styrofoam packing peanuts. This he proceeded to wedge behind my back like a makeshift beanbag chair.</p>
<p class="indent">“Better?” He made a few adjustments as I nodded, unwilling to acknowledge his act of chivalry. I rested my hands in my lap, letting his right hand — manacled to my left — graze my outer thigh. Ordinarily, I wouldn’t have tolerated such close physical proximity from a guy like Caleb, but in one short night, he and I had already been through an extraordinary saga of events. I leaned in to touch my shoulder to his as the reality of the situation sunk in.</p>
<p class="indent">“Caleb?”</p>
<p class="indent">“Yeah?”</p>
<p class="indent">“I’m scared.” Without looking at me, or saying a word, he rotated his wrist to clutch my hand in his. It was strong and guitar-calloused, and I knew that it was my one saving grace in this absurdly surreal night. At least we were in this together.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pro.vue?3a0b4092